import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allUsers } from "../user/userSlice";
import Swal from "sweetalert2";
import { formatDateToDDMMYYYY } from "../../uitls/Utils";
import {
  getAllUsers,
  deleteUserById,
  getManagersByRoleId,
  uploadMultipleEmployees,
  mfaSetup,
  resendWelcomeEmail,
  uploadBunchEmployee,
} from "../../api/userApi";
import { ROLE_OPTIONS } from "../../uitls/Contant";
import { Tooltip, IconButton } from "@mui/material";
import { Send, CheckCircle, Cancel, Email } from "@mui/icons-material";
import { showNotification } from "../../components/Notification";

import { useNavigate } from "react-router-dom";
import GridTable from "../../components/GridTable";
import { getAllDepartment } from "../../api/departmentApi";

const Employee = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allEmployees = useSelector(allUsers);
  useEffect(() => {
    dispatch(getAllUsers());
    dispatch(
      getManagersByRoleId(
        ROLE_OPTIONS.find((role) => role.label === "manager")?.value
      )
    );
  }, [dispatch]);

  const [resendingMfa, setResendingMfa] = useState({});
  const [resendingWelcome, setResendingWelcome] = useState({});

    useEffect(() => {
      dispatch(getAllDepartment());
    }, [dispatch]);
  

  const handleResendWelcomeEmail = async (user) => {
    const userId = user.id;
    setResendingWelcome((prev) => ({ ...prev, [userId]: true }));

    try {
      console.log("Resending welcome email to:", user.corporateEmail);
      const result = await dispatch(resendWelcomeEmail(userId)).unwrap();
      console.log("Resend welcome email API response:", result);
      
      showNotification(
        "success",
        `Welcome email has been resent to ${user.corporateEmail}. Please check your email (including spam folder).`
      );
    } catch (error) {
      console.error("Error resending welcome email:", error);
      const errorMessage = error?.response?.data?.message || 
                          error?.message || 
                          error?.error || 
                          "Failed to resend welcome email. Please try again.";
      showNotification(
        "error",
        errorMessage
      );
    } finally {
      setResendingWelcome((prev) => ({ ...prev, [userId]: false }));
    }
  };

  const handleResendMfa = async (user) => {
    const userId = user.id;
    setResendingMfa((prev) => ({ ...prev, [userId]: true }));

    try {
      console.log("Resending MFA invitation to:", user.corporateEmail);
      const result = await dispatch(mfaSetup(user.corporateEmail)).unwrap();
      console.log("MFA setup API response:", result);
      
      showNotification(
        "success",
        `MFA invitation has been sent to ${user.corporateEmail}. Please check your email (including spam folder).`
      );

      // Refresh the user list to get updated MFA status
      dispatch(getAllUsers());
    } catch (error) {
      console.error("Error sending MFA invitation:", error);
      const errorMessage = error?.response?.data?.message || 
                          error?.message || 
                          error?.error || 
                          "Failed to send MFA invitation. Please ensure the backend is running and try again.";
      showNotification(
        "error",
        errorMessage
      );
    } finally {
      setResendingMfa((prev) => ({ ...prev, [userId]: false }));
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {params.row?.firstName} {params.row?.lastName}
        </span>
      ),
    },
    {
      field: "corporateEmail",
      headerName: "Organizational Email",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {ROLE_OPTIONS.find(
            (role) => role.value === params.row.userRoleId
          )?.label?.toUpperCase()}
        </span>
      ),
    },
    {
      field: "manager",
      headerName: "Manager Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{params.row.manager?.name}</span>,
    },
    {
      field: "departmentId",
      headerName: "Department",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{params.value?.departmentName}</span>,
    },
    {
      field: "mfaStatus",
      headerName: "MFA Status",
      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const isMfaEnabled = params.row.mfaEnabled === true;
        return (
          <div className="flex items-center gap-2">
            {isMfaEnabled ? (
              <Tooltip title="MFA Verified">
                <div className="flex items-center gap-1 text-green-600">
                  <CheckCircle style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Verified</span>
                </div>
              </Tooltip>
            ) : (
              <Tooltip title="MFA Not Verified">
                <div className="flex items-center gap-1 text-orange-600">
                  <Cancel style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Not Verified</span>
                </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    // {
    //   field: "mfaAction",
    //   headerName: "MFA Action",
    //   width: 150,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     const isMfaEnabled = params.row.mfaEnabled === true;
    //     const userId = params.row.id;
    //     const isResending = resendingMfa[userId] || false;

    //     if (isMfaEnabled) {
    //       return (
    //         <span className="text-gray-400 text-sm">N/A</span>
    //       );
    //     }

    //     return (
    //       <Tooltip title="Resend MFA Invitation">
    //         <IconButton
    //           onClick={() => handleResendMfa(params.row)}
    //           disabled={isResending}
    //           size="small"
    //           className="text-blue-600 hover:text-blue-700 hover:bg-blue-50 transition-all duration-200"
    //           style={{
    //             padding: "6px",
    //           }}
    //         >
    //           <Send
    //             style={{
    //               fontSize: "18px",
    //               animation: isResending ? "spin 1s linear infinite" : "none",
    //             }}
    //           />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      field: "welcomeEmailAction",
      headerName: "Welcome Email",
      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const userId = params.row.id;
        const isResending = resendingWelcome[userId] || false;
        
        // Disable resend welcome email for verified users (MFA enabled)
        // Also disable if user has logged in and set up MFA
        const hasMfaEnabled = params.row.mfaEnabled === true;
        const hasLoggedIn = params.row.isTempPasswordChanged === true;
        
        // Disable if user is verified (MFA enabled) OR has completed both login and MFA setup
        const isVerified = hasMfaEnabled;
        const hasCompletedSetup = hasLoggedIn && hasMfaEnabled;
        const shouldDisable = isVerified || hasCompletedSetup;

        if (shouldDisable) {
          return (
            <Tooltip title={isVerified ? "User is verified (MFA enabled)" : "User has already logged in and set up MFA"}>
              <span className="text-gray-400 text-sm">N/A</span>
            </Tooltip>
          );
        }

        return (
          <Tooltip title="Resend Welcome Email">
            <IconButton
              onClick={() => handleResendWelcomeEmail(params.row)}
              disabled={isResending}
              size="small"
              className="text-green-600 hover:text-green-700 hover:bg-green-50 transition-all duration-200"
              style={{
                padding: "6px",
              }}
            >
              <Email
                style={{
                  fontSize: "18px",
                  animation: isResending ? "spin 1s linear infinite" : "none",
                }}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
  ];

  // Remove the useEffect that was setting rows state - we'll pass allEmployees directly to GridTable

  const handleDelete = (id) => {
    Swal.fire({
      titleText: "Delete Employee ?",
      text: "Are you sure want to delete this employee?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626", // Red for destructive action
      cancelButtonColor: "#3C50E0", // Primary color for cancel
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-width", // Custom width of the popup
        icon: "custom-swal-icon", // Custom icon size
        title: "custom-swal-title", // Custom title size
        content: "custom-swal-content", // Custom content (text) size
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUserById(id));
      }
    });
  };

  const handleCsvUpload=async(file)=>{
  
     const formData = new FormData();
        if (file && file instanceof File) {
          formData.append("file", file);
        }
          try {
      const result = await dispatch(uploadBunchEmployee(formData)).unwrap();
      Swal.fire({
        icon: "success",
        title: "Employees imported",
        text: result?.message || "Upload successful",
        timer: 2000,
        showConfirmButton: false,
      });
      // Refresh the employee list
      dispatch(getAllUsers());
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Import failed",
        text: e?.message || "Something went wrong",
      });
  }

}

  const onClickAction = (actionType, row, id) => {
    if (actionType === "EDIT") {
      navigate("/admin/employee/add-update?id=" + id);
    } else if (actionType === "DELETE") {
      handleDelete(id);
    }
  };

  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      <GridTable
        onClickAction={onClickAction}
        actions={["DELETE", "EDIT"]}
        rowData={allEmployees || []}
        columnData={columns}
        toolTipName="Add Employee"
        onClickAdd={() => navigate("/admin/employee/add-update")}
        topActionButtonTitle="Add"
        onCsvUpload={handleCsvUpload}
      />
    </div>
  );
};

export default Employee;
